import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router,
  CanActivateFn,
} from '@angular/router';
import { SuscripcionService } from '../services/suscripcion.service';
import { Observable } from 'rxjs';
import { KeycloakService } from 'keycloak-angular';
import { CommunityPanelService } from 'src/app/modules/communities/community-panel/community-panel.service';

export const SuscriptionGuard = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
  redirect: string = '/unite',
):
  | Observable<boolean | UrlTree>
  | Promise<boolean | UrlTree>
  | boolean
  | UrlTree => {
  const suscribed = inject(SuscripcionService).isSuscriptorSync();
  if (!suscribed) inject(Router).navigate([redirect]);
  return suscribed;
};

export const CommunitySuscriptionGuard: CanActivateFn = async (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
  redirect: string = '/unite',
): Promise<boolean | UrlTree> => {
  const router = inject(Router);
  const itemId = route.params['id'];
  const communityPanelService = inject(CommunityPanelService);
  const comm = communityPanelService.initialize(itemId);
  if (!comm) return router.createUrlTree(['/']);

  const suscriptionAccess = communityPanelService.isSuscriptionAccess();

  if (!suscriptionAccess) {
    return true;
  }

  const suscribed = inject(SuscripcionService).isSuscriptorSync();
  if (!suscribed) inject(Router).navigate([redirect]);
  return suscribed;
};
